<template>
  <div class="container">
    <nav class="navbar fixed-top bg-light">
        <div class="col-6 my-2 px-0 input-group">
          <input class="form-control" type="text" v-model="filter" placeholder="Search" ref="search">
          <div class="input-group-append">
            <button class="btn btn-outline-info" type="button" @click="$router.push('/customers')"><i class="fas fa-male"></i></button>
          </div>
        </div>
    </nav>

    <div class="list-group" id="cust-list">
      <router-link :to="`/customers/${c.CustomerId}?c=${c.ContactId}`" class="list-group-item list-group-item-action" v-for="c in contacts" :key="c.ContactId">
        {{ c.Firstname + ' ' + c.Lastname }}<br>
        {{ c.Position }}<br v-if="c.Position">
        {{ c.Customer }}
      </router-link>
    </div>
  </div>
</template>

<script>
import appService from '@/appService'

export default {
  data () {
    return {
      filter: '',
      contacts: []
    }
  },

  mounted() {
    this.$refs.search.focus()
  },

  watch: {
    filter: function() {
      if (this.filter.length > 0) {
        appService.searchContacts(this.filter).then(res => this.contacts = res)
      }
    }
  },
}
</script>
<style>
#cust-list {
  padding-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactList.vue